import React, { ReactElement } from "react";

import { ContentListGridSizerProps } from "../layout/editor/content-list-grid-sizer";

import { GraphicList, GraphicListProps, GraphicListRef } from "./graphic-list";

export type GraphicsPanelProps = Pick<
  GraphicListProps,
  "handleGraphicClick" | "query" | "filters"
> &
  Pick<ContentListGridSizerProps, "gridSize"> & {
    graphicListRef: React.RefObject<GraphicListRef>;
  };

export default function GraphicsPanel({
  handleGraphicClick,
  query,
  filters,
  gridSize,
  graphicListRef,
}: GraphicsPanelProps): ReactElement {
  return (
    <GraphicList
      ref={graphicListRef}
      query={query}
      filters={filters}
      gridSize={gridSize}
      handleGraphicClick={handleGraphicClick}
    />
  );
}
